// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2aybf","clinicsSelect":"styles_clinicsSelect__3XlR1"};